import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { SimpleTable as SimpleTableType } from "../../../common/types/post.types";

function SimpleTable(props: Props) {
  const tableData = props.data;
  const columnIds: string[] = [];
  const columns = tableData.columns.map((data) => {
    columnIds.push(data.id);
    return <TableCell align={data.align ?? undefined} key={data.id}>{data.name}</TableCell>
  })
  return (
    <TableContainer component={Paper} className={'simple-table'} style={{width: props.width ?? '100%'}}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data.data.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              {
                columnIds.map((id) => <TableCell key={id} align={getAlignOfColumn(id, tableData.columns)}>{row[id]}</TableCell>)
              }
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

function getAlignOfColumn(columnId: string, columnData: any[]) {
      return columnData.find((data) => data.id === columnId)?.align ?? undefined;
}

export default SimpleTable;

class Props {
  data: SimpleTableType;
  width?: string;
}
